import { connect } from 'react-redux'
import { Badge, ButtonStack, Grid, Typography } from 'maple-storybook'
import { alertTriangle, Icon, trash } from 'maple-storybook/assets'

import { HIDE_MODAL } from 'actions/modal'
import AvatarWithLabelOption from 'components/AvatarWithLabelOption/AvatarWithLabelOption'
import Button from 'components/CustomButtons/Button'
import { checkArrayPresence } from 'helpers/applicationHelper'
import { affectedClaimTypeBadges, claimImpactAmount, claimsCountLabel } from 'helpers/claimsHelper'

import './FinancialClaimsImpactSummary.scss'

const FinancialClaimsImpactSummary = ({
  claimTypes,
  claimsImpacted,
  totals = {},
  heading = 'Financial Impact Summary',
  warning,
  confirmLabel = 'Confirm',
  onConfirm,
  closeModal,
  submission
}) => (
  <Grid className="financial-impact-summary p-1">
    <Grid className="impact-summary-heading d-flex align-items-center flex-wrap gp-10">
      <Typography variant="text-sm" type="semibold" color="gray-500" textTransformCap>
        {heading}
      </Typography>
      {affectedClaimTypeBadges(claimTypes).map((claimTypeBadge) => (
        <Badge key={claimTypeBadge.name} size="md" variant={claimTypeBadge.variant} label={claimTypeBadge.name} />
      ))}
    </Grid>
    {checkArrayPresence(claimTypes) ? (
      <Grid className="impact-summary-card rounded-border mt-1">
        <Grid className="impact-summary-header d-flex align-items-center justify-space-between p-1">
          <Grid className="d-flex align-items-center gp-10">
            <Typography variant="text-md" type="semibold" color="gray-900">
              Claims Impacted
            </Typography>
            <Badge size="md" variant="blue" className="impact-count-badge" label={claimsCountLabel(claimsImpacted)} />
          </Grid>
          <Grid className="d-flex align-items-center gp-10">
            {Object.entries(totals).map(([currency, total]) => (
              <Typography key={currency} variant="text-md" type="semibold" color="error-600" noTransform>
                {claimImpactAmount(total, currency)}
              </Typography>
            ))}
          </Grid>
        </Grid>
        {claimTypes.map((claimType) => (
          <Grid key={`${claimType.id}-${claimType.currency}`} className="impact-claim-type">
            <Grid className="impact-claim-type-header d-flex align-items-center justify-space-between">
              <Typography variant="text-xs" type="semibold" color="gray-500" textTransformCap>
                {claimType.name}
              </Typography>
              <Grid className="d-flex align-items-center gp-10">
                <Badge
                  size="sm"
                  variant="blue"
                  className="impact-count-badge"
                  label={claimsCountLabel(claimType.count)}
                />
                <Typography variant="text-sm" type="bold" color="error-700" noTransform>
                  {claimImpactAmount(claimType.amount, claimType.currency)}
                </Typography>
              </Grid>
            </Grid>
            <Grid className="impact-employees-scroll">
              {checkArrayPresence(claimType.employees) &&
                claimType.employees.map((employee) => (
                  <Grid
                    key={employee.id}
                    className="impact-employee-row d-flex align-items-center justify-space-between">
                    <AvatarWithLabelOption
                      avatar={employee.avatar}
                      label={employee.name}
                      id={employee.id}
                      userOffboardingStatus={employee.user_offboarding_status}
                    />
                    <Typography variant="text-sm" type="semibold" color="error-600" noTransform>
                      {claimImpactAmount(employee.amount, claimType.currency)}
                    </Typography>
                  </Grid>
                ))}
            </Grid>
          </Grid>
        ))}
      </Grid>
    ) : (
      <Grid className="impact-summary-card impact-empty-state rounded-border mt-1 p-1">
        <Typography variant="text-sm" color="gray-500" noTransform>
          No financial impact
        </Typography>
      </Grid>
    )}
    {warning && (
      <Grid className="impact-warning-note d-flex align-items-center gp-10 p-1 mt-1">
        <Icon paths={alertTriangle} strokeColor="warning-600" fillColor="warning-50" size={20} viewBox="0 0 20 20" />
        <Typography variant="text-sm" color="gray-700" noTransform>
          {warning}
        </Typography>
      </Grid>
    )}
    {onConfirm && (
      <ButtonStack className="impact-actions mt-1">
        <Button type="button" variant="secondaryGray" disabled={submission} onClick={closeModal}>
          Cancel
        </Button>
        <Button
          type="button"
          variant="dangerPrimary"
          disabled={submission}
          startIcon={<Icon paths={trash} strokeColor="white" fill="none" size={18} />}
          onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </ButtonStack>
    )}
  </Grid>
)

const mapStateToProps = (state) => ({
  submission: state.formSubmission.submission
})

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => {
    dispatch(HIDE_MODAL)
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(FinancialClaimsImpactSummary)
